/**
 * The tour's header: where you are ("3 of 10"), one dot per chapter
 * (visited = filled, open = ringed), and Start over.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import { GraduationCap } from 'lucide-react';

export const ChapterHeader: FC<{
  open: number;
  total: number;
  visited: number[];
  onJump: (n: number) => void;
  onStartOver: () => void;
}> = ({ open, total, visited, onJump, onStartOver }) => (
  <div className="flex flex-wrap items-center gap-3 rounded-lg border border-border/60 bg-card px-4 py-3">
    <GraduationCap className="h-4 w-4 text-primary" />
    <span className="text-sm font-semibold">How it works</span>
    <span className="text-xs text-muted-foreground">
      the whole tool in ten short chapters — nothing here writes anything
    </span>
    <span className="grow" />
    <span className="font-mono text-xs tabular-nums text-muted-foreground">
      {open} of {total}
    </span>
    <span className="flex items-center gap-1" aria-label="chapters">
      {Array.from({ length: total }, (_, i) => i + 1).map((n) => (
        <button
          key={n}
          type="button"
          aria-label={`chapter ${n}`}
          aria-current={n === open ? 'step' : undefined}
          onClick={() => onJump(n)}
          className={`h-2 w-2 rounded-full ${
            n === open
              ? 'bg-primary ring-2 ring-primary/30'
              : visited.includes(n)
                ? 'bg-primary/60'
                : 'bg-muted-foreground/30'
          }`}
        />
      ))}
    </span>
    <button
      type="button"
      onClick={onStartOver}
      className="text-xs font-medium text-muted-foreground hover:text-foreground"
    >
      Start over
    </button>
  </div>
);
